export default {
    cityCommit(state, payload){
        state.cities = payload
    },
    districtCommit(state, payload){
        state.district = payload
    },
}
